const cvs = [
  {
    name: "My CV - EN",
    lastEdit: "2022/05/02",
  },
  {
    name: "My CV - ES",
    lastEdit: "2022/05/02",
  },
  {
    name: "Proffessional - EN",
    lastEdit: "2022/05/02",
  },
];

const templates = {
  "Lic. Paula Giroud": {
    age: 0,
    working: true,
    experience: {
      company: "",
      role: {
        "time in role": "",
        "scope of role": "",
        "tecnologies applied": ["trello", "canvas"],
      },
    },
  },
  " HSBC HHRR team": {
    email: "",
    age: 99,
    working: true,
    problem: null,
    moreinfo: {
      car: {
        brand: "a-brand",
        year: 2020,
        owners: ["father", "brother"],
      },
    },
  },
  "LinkedIn HHRR team": {
    email: "",
    age: 99,
    working: true,
    problem: null,
    "more info": {
      car: {
        brand: "a-brand",
        year: 2020,
        owners: ["father", "brother"],
      },
    },
  },
  "Simple Resume template": {
    email: "",
    age: 99,
    working: true,
    problem: null,
    "more info": {
      car: {
        brand: "a-brand",
        year: 2020,
        owners: ["father", "brother"],
      },
    },
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { cvs, templates };
